exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yazdirtable[data-v-55285fc2]{display:block}.YpImage[data-v-55285fc2]{max-height:80px;max-width:50%}.yazdirtable table.table-lg tr td[data-v-55285fc2],table.yazdirtable.table-lg tr th[data-v-55285fc2]{font-size:12px!important}.kesimcizgi[data-v-55285fc2]{width:100%;border-bottom:1px dashed #000;margin-top:20px;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55285fc2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/JetUsta/Comp/juTalepForm.vue
// module id = 1155
// module chunks = 0